export enum TransportAgreementTypeEnum {
  NINGUNO = 'Ninguno',
  CONVENIO = 'Convenio',
  CONSORCIO = 'Consorcio',
  UNION_TEMPORAL = 'Unión Temporal',
}
